import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

// Wait for any dynamic imports to load before hydrating
window.addEventListener('load', () => {
  ReactDOM.hydrateRoot(
    document.getElementById('root')!,
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  );
});